export default function Arrowright({ style, stroke = '#006FAD' }) {
  return (
    <svg
      className={style}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 8.00109V6.22109C4 4.01442 5.56667 3.10775 7.48 4.21442L9.02 5.10775L10.56 6.00109C12.4733 7.10775 12.4733 8.91442 10.56 10.0211L9.02 10.9144L7.48 11.8078C5.56667 12.8944 4 11.9944 4 9.78109V8.00109Z'
        stroke={stroke}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

